"use client";

import { useState, useEffect } from "react";
import "./HomePage.css";

const HomePage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [stats, setStats] = useState({
    influencers: 0,
    companies: 0,
    campaigns: 0,
    connections: 0,
  });

  const testimonials = [
    {
      name: "سارة أحمد",
      role: "مؤثرة في مجال الموضة",
      content:
        "فواصل ساعدني في الوصول لعلامات تجارية مميزة وزيادة دخلي بشكل كبير. المنصة سهلة الاستخدام ومليئة بالفرص.",
      rating: 5,
      avatar: "/placeholder.svg?height=60&width=60&text=سارة",
    },
    {
      name: "محمد العلي",
      role: "مدير تسويق - شركة النور",
      content:
        "وجدنا أفضل المؤثرين لحملاتنا التسويقية من خلال فواصل. النتائج فاقت توقعاتنا والعائد على الاستثمار ممتاز.",
      rating: 5,
      avatar: "/placeholder.svg?height=60&width=60&text=محمد",
    },
    {
      name: "فاطمة حسن",
      role: "مؤثرة في مجال الطبخ",
      content:
        "أحب كيف تجعل فواصل عملية التواصل مع الشركات بسيطة وشفافة. حققت شراكات رائعة من خلال المنصة.",
      rating: 5,
      avatar: "/placeholder.svg?height=60&width=60&text=فاطمة",
    },
  ];

  const features = [
    {
      icon: "fas fa-search",
      title: "اكتشاف ذكي",
      description: "خوارزمية متقدمة لربط المؤثرين بالعلامات التجارية المناسبة",
      color: "#4358a6",
    },
    {
      icon: "fas fa-handshake",
      title: "تعاون سهل",
      description: "أدوات تواصل وإدارة مشاريع متكاملة لضمان نجاح الشراكات",
      color: "#4a9eff",
    },
    {
      icon: "fas fa-chart-line",
      title: "تتبع الأداء",
      description: "تحليلات مفصلة لقياس نجاح الحملات وتحسين النتائج",
      color: "#06b6d4",
    },
    {
      icon: "fas fa-shield-alt",
      title: "دفع آمن",
      description: "نظام دفع محمي ومضمون لجميع المعاملات المالية",
      color: "#10b981",
    },
  ];

  const howItWorks = [
    {
      icon: "fas fa-user-plus",
      title: "أنشئ حسابك",
      description: "سجل كمؤثر أو شركة واملأ ملفك الشخصي",
      color: "#4358a6",
    },
    {
      icon: "fas fa-search",
      title: "اكتشف الفرص",
      description: "تصفح الحملات المتاحة أو ابحث عن المؤثرين المناسبين",
      color: "#4a9eff",
    },
    {
      icon: "fas fa-comments",
      title: "تواصل وتفاوض",
      description: "تواصل مباشرة وحدد تفاصيل التعاون والأسعار",
      color: "#06b6d4",
    },
    {
      icon: "fas fa-rocket",
      title: "أطلق حملتك",
      description: "ابدأ التعاون وتتبع النتائج في الوقت الفعلي",
      color: "#10b981",
    },
  ];

  const featuredCampaigns = [
    {
      id: 1,
      title: "حملة منتجات التجميل الطبيعية",
      category: "موضة وجمال",
      budget: "$500 - $1000",
      image: "/placeholder.svg?height=180&width=280&text=حملة+التجميل",
      distance: "2.3",
    },
    {
      id: 2,
      title: "مراجعة تطبيق الطبخ الجديد",
      category: "طعام وشراب",
      budget: "$200 - $400",
      image: "/placeholder.svg?height=180&width=280&text=تطبيق+الطبخ",
      distance: "1.8",
    },
    {
      id: 3,
      title: "ترويج منتجات التقنية",
      category: "تقنية",
      budget: "$800 - $1200",
      image: "/placeholder.svg?height=180&width=280&text=منتجات+التقنية",
      distance: "3.1",
    },
  ];

  const topInfluencers = [
    {
      id: 1,
      name: "أحمد محمد",
      specialty: "تقنية",
      followers: "125K",
      image: "/placeholder.svg?height=200&width=150&text=أحمد",
    },
    {
      id: 2,
      name: "فاطمة علي",
      specialty: "موضة",
      followers: "89K",
      image: "/placeholder.svg?height=200&width=150&text=فاطمة",
    },
    {
      id: 3,
      name: "محمد حسن",
      specialty: "طعام",
      followers: "156K",
      image: "/placeholder.svg?height=200&width=150&text=محمد",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  useEffect(() => {
    const animateStats = () => {
      const duration = 2000;
      const steps = 60;
      const stepDuration = duration / steps;

      const targets = {
        influencers: 15000,
        companies: 3500,
        campaigns: 8500,
        connections: 25000,
      };

      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;

        setStats({
          influencers: Math.floor(targets.influencers * progress),
          companies: Math.floor(targets.companies * progress),
          campaigns: Math.floor(targets.campaigns * progress),
          connections: Math.floor(targets.connections * progress),
        });

        if (step >= steps) {
          clearInterval(timer);
        }
      }, stepDuration);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateStats();
          observer.unobserve(entry.target);
        }
      });
    });

    const statsSection = document.querySelector(".stats-section");
    if (statsSection) {
      observer.observe(statsSection);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="homepage">
      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-brand">
            <div className="brand-logo">
              <span className="logo-icon">
                <i className="fas fa-link"></i>
              </span>
              <span className="logo-text">فواصل</span>
            </div>
          </div>
          <div className="nav-menu">
            <a href="#features" className="nav-link">
              الميزات
            </a>
            <a href="#how-it-works" className="nav-link">
              كيف يعمل
            </a>
            <a href="#testimonials" className="nav-link">
              آراء العملاء
            </a>
            <div className="nav-buttons">
              <button className="btn btn-ghost">تسجيل الدخول</button>
              <button className="btn btn-primary">ابدأ مجاناً</button>
            </div>
          </div>
          <div className="mobile-menu-toggle">
            <i className="fas fa-bars"></i>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
          </div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <i className="fas fa-star"></i>
                <span>المنصة الرائدة لربط المؤثرين بالشركات</span>
              </div>
              <h1 className="hero-title">
                اربط علامتك التجارية
                <br />
                مع أفضل
                <span className="gradient-text"> المؤثرين</span>
              </h1>
              <p className="hero-subtitle">
                منصة فواصل تجمع المؤثرين والشركات في مكان واحد لإنشاء شراكات
                ناجحة وحملات تسويقية مؤثرة تحقق نتائج استثنائية
              </p>
              <div className="hero-buttons">
                <button className="btn btn-primary btn-large">
                  <i className="fas fa-rocket"></i>
                  ابدأ مجاناً الآن
                </button>
                <button className="btn btn-secondary btn-large">
                  <i className="fas fa-play"></i>
                  شاهد كيف يعمل
                </button>
              </div>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">15K+</div>
                  <div className="stat-label">مؤثر نشط</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">3.5K+</div>
                  <div className="stat-label">شركة</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">25K+</div>
                  <div className="stat-label">شراكة ناجحة</div>
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="app-mockup">
                <div className="phone-mockup">
                  <div className="phone-frame">
                    <div className="phone-screen">
                      <div className="screen-header">
                        <div className="status-bar">
                          <span className="time">9:41</span>
                          <div className="indicators">
                            <i className="fas fa-signal"></i>
                            <i className="fas fa-wifi"></i>
                            <i className="fas fa-battery-three-quarters"></i>
                          </div>
                        </div>
                        <div className="app-header">
                          <button className="menu-btn">
                            <i className="fas fa-bars"></i>
                          </button>
                          <div className="welcome-section">
                            <span className="welcome-text">Welcome 👋</span>
                            <span className="user-name">أحمد محمد</span>
                          </div>
                          <button className="notification-btn">
                            <i className="fas fa-bell"></i>
                            <span className="notification-badge">3</span>
                          </button>
                        </div>
                      </div>
                      <div className="screen-content">
                        <div className="search-bar">
                          <i className="fas fa-search"></i>
                          <span>ابحث عن حملات أو مؤثرين...</span>
                        </div>
                        <div className="section-title">Featured Campaigns</div>
                        <div className="campaign-cards">
                          <div className="campaign-card">
                            <div className="campaign-image"></div>
                            <div className="campaign-info">
                              <div className="campaign-badges">
                                <span className="category-badge">
                                  <i className="fas fa-fire"></i>
                                  موضة
                                </span>
                                <span className="distance-badge">
                                  <i className="fas fa-map-marker-alt"></i>
                                  2.3 Km
                                </span>
                              </div>
                              <h4>حملة منتجات التجميل</h4>
                              <p className="budget">$500 - $1000</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="floating-elements">
                  <div className="floating-card card-1">
                    <div className="card-icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="card-content">
                      <div className="card-title">مؤثرين جدد</div>
                      <div className="card-value">+127</div>
                    </div>
                  </div>
                  <div className="floating-card card-2">
                    <div className="card-icon">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <div className="card-content">
                      <div className="card-title">نمو الحملات</div>
                      <div className="card-value">+45%</div>
                    </div>
                  </div>
                  <div className="floating-card card-3">
                    <div className="card-icon">
                      <i className="fas fa-star"></i>
                    </div>
                    <div className="card-content">
                      <div className="card-title">تقييم المنصة</div>
                      <div className="card-value">4.9/5</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Campaigns Section */}
      <section className="featured-campaigns-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">الحملات المميزة</h2>
            <a href="#" className="view-all-link">
              عرض الكل
            </a>
          </div>
          <div className="campaigns-grid">
            {featuredCampaigns.map((campaign, index) => (
              <div key={campaign.id} className="campaign-card-large">
                <div className="campaign-image-container">
                  <img
                    src={campaign.image || "/placeholder.svg"}
                    alt={campaign.title}
                    className="campaign-image"
                  />
                  <div className="campaign-badges">
                    <span className="category-badge">
                      <i className="fas fa-fire"></i>
                      {campaign.category}
                    </span>
                    <span className="distance-badge">
                      <i className="fas fa-map-marker-alt"></i>
                      {campaign.distance} Km
                    </span>
                  </div>
                </div>
                <div className="campaign-info">
                  <h3 className="campaign-title">{campaign.title}</h3>
                  <div className="campaign-budget">
                    <span className="budget-label">الميزانية:</span>
                    <span className="budget-amount">{campaign.budget}</span>
                  </div>
                  <button className="details-btn">عرض التفاصيل</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section" id="features">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">ميزاتنا</div>
            <h2 className="section-title">لماذا تختار فواصل؟</h2>
            <p className="section-subtitle">
              نقدم مجموعة شاملة من الأدوات والخدمات لضمان نجاح شراكاتك التسويقية
            </p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className="feature-card"
                style={{ "--feature-color": feature.color }}
              >
                <div className="feature-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section" id="how-it-works">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">العملية</div>
            <h2 className="section-title">كيف يعمل فواصل؟</h2>
            <p className="section-subtitle">
              أربع خطوات بسيطة لبدء رحلتك في عالم التسويق بالمؤثرين
            </p>
          </div>
          <div className="steps-grid">
            {howItWorks.map((step, index) => (
              <div
                key={index}
                className="step-card"
                style={{ "--step-color": step.color }}
              >
                <div className="step-number">{index + 1}</div>
                <div className="step-icon">
                  <i className={step.icon}></i>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Top Influencers Section */}
      <section className="influencers-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">أفضل المؤثرين</h2>
            <a href="#" className="view-all-link">
              عرض الكل
            </a>
          </div>
          <div className="influencers-grid">
            {topInfluencers.map((influencer, index) => (
              <div key={influencer.id} className="influencer-card">
                <div className="influencer-image-container">
                  <img
                    src={influencer.image || "/placeholder.svg"}
                    alt={influencer.name}
                    className="influencer-image"
                  />
                  <div className="influencer-overlay">
                    <div className="influencer-info">
                      <h4 className="influencer-name">{influencer.name}</h4>
                      <p className="influencer-specialty">
                        {influencer.specialty}
                      </p>
                      <p className="influencer-followers">
                        {influencer.followers} متابع
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-content">
            <div className="stats-text">
              <h2 className="stats-title">أرقام تتحدث عن نفسها</h2>
              <p className="stats-subtitle">
                انضم إلى آلاف المؤثرين والشركات الذين يثقون بفواصل
              </p>
            </div>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">
                  {stats.influencers.toLocaleString()}
                </div>
                <div className="stat-label">مؤثر نشط</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {stats.companies.toLocaleString()}
                </div>
                <div className="stat-label">شركة مسجلة</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {stats.campaigns.toLocaleString()}
                </div>
                <div className="stat-label">حملة ناجحة</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {stats.connections.toLocaleString()}
                </div>
                <div className="stat-label">شراكة محققة</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section" id="testimonials">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">آراء العملاء</div>
            <h2 className="section-title">ماذا يقول مستخدمونا��</h2>
            <p className="section-subtitle">
              اكتشف تجارب حقيقية من مؤثرين وشركات نجحوا معنا
            </p>
          </div>
          <div className="testimonial-container">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <div className="quote-icon">
                  <i className="fas fa-quote-left"></i>
                </div>
                <p className="testimonial-text">
                  {testimonials[currentTestimonial].content}
                </p>
                <div className="testimonial-rating">
                  {[...Array(testimonials[currentTestimonial].rating)].map(
                    (_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    )
                  )}
                </div>
                <div className="testimonial-author">
                  <img
                    src={
                      testimonials[currentTestimonial].avatar ||
                      "/placeholder.svg"
                    }
                    alt={testimonials[currentTestimonial].name}
                    className="author-avatar"
                  />
                  <div className="author-info">
                    <h4 className="author-name">
                      {testimonials[currentTestimonial].name}
                    </h4>
                    <p className="author-role">
                      {testimonials[currentTestimonial].role}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial-indicators">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${
                    index === currentTestimonial ? "active" : ""
                  }`}
                  onClick={() => setCurrentTestimonial(index)}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-shapes">
            <div className="cta-shape cta-shape-1"></div>
            <div className="cta-shape cta-shape-2"></div>
          </div>
        </div>
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">هل أنت مستعد لبدء رحلتك؟</h2>
            <p className="cta-subtitle">
              انضم إلى آلاف المؤثرين والشركات الذين يحققون نجاحات استثنائية من
              خلال فواصل
            </p>
            <div className="cta-buttons">
              <button className="btn btn-white btn-large">
                <i className="fas fa-rocket"></i>
                ابدأ مجاناً الآن
              </button>
              <button className="btn btn-outline-white btn-large">
                <i className="fas fa-phone"></i>
                تحدث مع فريق المبيعات
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="brand-logo">
                <span className="logo-icon">
                  <i className="fas fa-link"></i>
                </span>
                <span className="logo-text">فواصل</span>
              </div>
              <p className="brand-description">
                المنصة الرائدة التي تربط المؤثرين بالشركات في العالم العربي
                لإنشاء شراكات ناجحة ومؤثرة
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="copyright">© 2024 فواصل. جميع الحقوق محفوظة.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
